import './video.scss';

class TeaserVideo {
    constructor() {
        this.DOM = { video: document.querySelector('video') }
        // this.DOM.unmuteBtn = document.querySelector('#unmuteButton')
        // this.DOM.restartBtn = document.querySelector('#restartButton')
        this.DOM.playBtnTouch = document.querySelector('#play')
        this.observer = undefined;
        this.isPaused = true;
        this.isTouchDisplay = false;
        this.bindHandles();
        this.setTouchDisplay();
        this.initUi();
    }
    bindHandles() {
        ['handleUnmuteVideo', 'handleReplay', 'handlePlay', 'handlePause']
            .forEach((fn) => this[fn] = this[fn].bind(this))
    }
    setTouchDisplay() {
        if (window.matchMedia("(pointer: coarse)").matches) {
            this.isTouchDisplay = true
        }
    }
    initUi() {
        if (this.isTouchDisplay) {
            this.initTouchUi()
        } else {
            this.initDesktopUi()

        }
    }
    initDesktopUi() {
        // this.initObservation()
        this.initDesktopButtonEvents()
    }

    initTouchUi() {
        this.DOM.unmuteBtn.style.display = 'none';
        this.DOM.restartBtn.style.display = 'none';
        this.DOM.playBtnTouch.style.display = 'block';
        this.DOM.video.controls = false;
        this.DOM.video.muted = false;
        this.initTouchEvents();
    }

    // initObservation() {
    //     this.observer = new IntersectionObserver((entries, observer) => {
    //         entries.forEach(entry => {
    //             if (entry.intersectionRatio != 1 && !this.DOM.video.paused) {
    //                 this.DOM.video.pause();
    //                 this.isPaused = true;
    //             }
    //             else if (this.isPaused && entry.intersectionRatio == 1) {
    //                 this.DOM.video.play();
    //                 this.isPaused = false;
    //             }
    //         });
    //     }, { threshold: 1 });
    //     this.observer.observe(this.DOM.video);
    // }
    initDesktopButtonEvents() {
        // this.DOM.unmuteBtn.addEventListener('click', this.handleUnmuteVideo);
        // this.DOM.restartBtn.addEventListener('click', this.handleReplay);
        this.DOM.playBtnTouch.addEventListener('click', this.handlePlay);
        this.DOM.video.addEventListener('pause', this.handlePause);
    }
    initTouchEvents() {
        this.DOM.playBtnTouch.addEventListener('click', this.handlePlay);
        this.DOM.video.addEventListener('pause', this.handlePause);
    }

    handlePause(e) {
        this.DOM.playBtnTouch.style.display = 'block';
    }

    handlePlay(e) {
        this.DOM.video.controls = true;
        this.DOM.video.play();
        this.DOM.playBtnTouch.style.display = 'none';
    }

    handleUnmuteVideo(e) {
        this.DOM.video.muted = !this.DOM.video.muted;
        e.target.classList.toggle('line-through')
    }
    handleReplay(e) {
        this.DOM.video.currentTime = 0;
    }
    destroy() {
        this.observer.unobserve(this.DOM.video)
        this.DOM.unmuteBtn.removeEventListener('click', this.handleUnmuteVideo)
        this.DOM.restartBtn.removeEventListener('click', this.handleReplay)
        this.DOM.playBtnTouch.removeEventListener('click', this.handlePlay)
        this.DOM.playBtnTouch.removeEventListener('pause', this.handlePause)
    }
}

const videoSection = document.getElementById('video-teaser');
if (typeof (videoSection) != 'undefined' && videoSection != null) {
    new TeaserVideo();
}







